export const getLayoutWithoutData = layout => {
  let newLayout = { ...layout };

  let components = { ...newLayout.components };
  for (let i in components) {
    components[i] = { ...components[i], data: [] };
  }

  newLayout.components = components;

  return newLayout;
};



// WEBPACK FOOTER //
// ./src/utils/slide.js